import React, { Component, Fragment } from 'react';
import {
  showAccountsAction,
  createAccountAction,
  deleteAccountAction,
  checkShortcodeStatus,
  updateAccountAction,
} from 'store/modules/content';
import { HeaderLoggedIn } from 'scenes/Header';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import AlertMessage from 'components/AlertMessage';
import plusSvg from 'images/plus.svg';
import classnames from 'classnames';
import { getUrl } from 'helpers/getUrl';
import getEnv from 'helpers/getEnv';

import CreateNew from 'components/CreateNew';
import CreateDomainModal from 'components/CreateDomainModal';
import FixedFooter from 'components/FixedFooter';
import DomainCard from 'components/DomainCard';
import EmptyDomainCard from 'components/DomainCard/EmptyDomainCard';
import EditDomainModal from 'components/EditDomainModal';
import TrialUpgradeModal from 'components/TrialUpgradeModal';
import DeleteDomainModal from 'components/DomainCard/DeleteDomainModal';
import ProfitWellComponent from 'components/ProfitWellComponent';

class Domain extends Component {
  state = {
    isOpen: false,
    showAlertError: false,
    showAlertSuccess: false,
    alertTextError: '',
    alertTextSuccess: '',
    showModal: false,
    showModalEdit: false,
    showModalDelete: false,
    showModalTrial: false,
    editableDomainId: null,
    deleteDomainId: null,
    showPremiumEdit: false,
    showPremiumCreate: false,
  };

  componentDidMount() {
    const { showAccountsAction } = this.props;
    showAccountsAction();
  }

  handleEdit = async id => {
    const { showAccountsAction, updateAccountAction } = this.props;
    await updateAccountAction(id);
    showAccountsAction();
  };

  deleteDomain = async () => {
    const id = this.state.deleteDomainId;
    const { showAccountsAction, deleteAccountAction } = this.props;
    this.toggleModalDelete();
    await deleteAccountAction(id);
    showAccountsAction();
  };

  renderDomainCard = item => (
    <DomainCard
      id={item.id}
      {...item}
      key={item.id}
      toggleModalEdit={() => this.toggleModalEdit(item.id)}
      toggleModalDelete={() => this.toggleModalDelete(item.id)}
      handleDelete={() => this.handleDelete(item.id)}
      domainTitle={item.title}
      domainName={getEnv('REACT_APP_BACKEND_URL') + '/' + item.short_code} //for development purposes
      nonDeletable={this.props.accounts.length <= 1}
      // domainName={item.domain + '/' + item.short_code}
    />
  );

  createDomain = async (values, setSubmitting, setErrors, resetForm) => {
    const {
      createAccountAction,
      showAccountsAction,
      checkShortcodeStatus,
    } = this.props;
    const { showPremiumCreate } = this.props;
    const body = {
      account: {
        title: values.title,
        short_code: values.short_code.replace(/ /g, ''),
      },
    };
    const shortCode = await checkShortcodeStatus(
      values.short_code.replace(/ /g, ''),
      setSubmitting,
    );

    if (!shortCode.data.avaliable) {
      this.setState({
        showAlertError: true,
        alertTextError: shortCode.data.message,
      });
      setTimeout(
        () => this.setState({ showAlertError: false, alertTextError: '' }),
        4000,
      );
    } else {
      this.setState({
        showAlertSuccess: true,
        alertTextSuccess: shortCode.data.message,
      });
      setTimeout(
        () => this.setState({ showAlertSuccess: false, alertTextSuccess: '' }),
        4000,
      );
      const response = await createAccountAction(
        body,
        setSubmitting,
        setErrors,
      );
      resetForm();
      this.setState({
        showPremiumCreate: false,
      });
      this.toggleModal();
      showAccountsAction();
    }
  };

  editDomain = async (values, setSubmitting, setErrors, resetForm) => {
    const {
      createAccountAction,
      showAccountsAction,
      updateAccountAction,
      checkShortcodeStatus,
    } = this.props;
    const { showPremiumEdit } = this.state;
    const body = {
      account: {
        title: values.title,
        short_code: values.short_code.replace(/ /g, ''),
      },
    };
    const shortCode = await checkShortcodeStatus(
      values.short_code.replace(/ /g, ''),
      setSubmitting,
    );

    if (!shortCode.data.premium) {
      this.setState({
        showPremiumEdit: false,
      });
    }
    if (!shortCode.data.avaliable) {
      this.setState({
        showAlertError: true,
        alertTextError: shortCode.data.message,
      });
      setTimeout(
        () => this.setState({ showAlertError: false, alertTextError: '' }),
        4000,
      );
    } else {
      this.setState({
        showAlertSuccess: true,
        alertTextSuccess: shortCode.data.message,
      });
      setTimeout(
        () => this.setState({ showAlertSuccess: false, alertTextSuccess: '' }),
        4000,
      );
      const id = this.state.editableDomainId;
      const response = await updateAccountAction(
        id,
        body,
        setSubmitting,
        setErrors,
      );
      resetForm();
      this.setState({
        showPremiumEdit: false,
      });
      this.toggleModalEdit();
      showAccountsAction();
    }
  };

  toggleModal = () => {
    this.setState(({ showModal }) => ({
      showModal: !showModal,
    }));
  };

  toggleModalEdit = id => {
    this.setState(({ showModalEdit }) => ({
      showModalEdit: !showModalEdit,
      editableDomainId: id ? id : null,
    }));
  };

  toggleModalDelete = id => {
    this.setState(({ showModalDelete }) => ({
      showModalDelete: !showModalDelete,
      deleteDomainId: id ? id : null,
    }));
  };

  toggleModalTrial = () => {
    this.setState(({ showModalTrial }) => ({
      showModalTrial: !showModalTrial,
    }));
  };

  handleCheckShortCode = async (v, type) => {
    const { checkShortcodeStatus } = this.props;
    if (v.name === 'short_code' && v.value.length > 0) {
      const shortCode = await checkShortcodeStatus(v.value.replace(/ /g, ''));
      if (shortCode.data && shortCode.data.premium) {
        if (type === 'edit') {
          this.setState({
            showPremiumEdit: true,
          });
        } else if (type === 'create') {
          this.setState({
            showPremiumCreate: true,
          });
        }
      } else if (shortCode.data && !shortCode.data.premium) {
        if (type === 'edit') {
          this.setState({
            showPremiumEdit: false,
          });
        } else if (type === 'create') {
          this.setState({
            showPremiumCreate: false,
          });
        }
      }
    }
  };

  render() {
    const {
      showAlertError,
      showAlertSuccess,
      alertTextError,
      alertTextSuccess,
      showModal,
      showModalEdit,
      showModalDelete,
      showModalTrial,
      showPremiumEdit,
      showPremiumCreate,
    } = this.state;
    const { subscription_plan } = this.props.details;
    const { isSubmitting } = this.props;
    const { accounts, details } = this.props;
    return (
      <Fragment>
        <ProfitWellComponent email={this.props.details.email}/>
        {showAlertSuccess && <AlertMessage text={alertTextSuccess} />}
        {showAlertError && (
          <AlertMessage
            classAlert={classnames({ error: true })}
            text={alertTextError}
          />
        )}
        <HeaderLoggedIn />
        <div className="main__content">
          <div className="domains">
            <div className="domains-topline">
              <div className="domains-topline__left">
                <h1 className="h1-title">My domains</h1>
              </div>
              <div className="domains-topline__right">
                {!details.trial && accounts.length !== 0 && (
                  <Fragment>
                    <Button
                      color="blue"
                      className="dtn btn-blue"
                      onClick={this.toggleModal}>
                      Buy extra domain
                    </Button>
                  </Fragment>
                )}
                {details.trial && (
                  <Fragment>
                    <Button
                      color="blue"
                      className="dtn btn-blue"
                      onClick={this.toggleModalTrial}>
                      Buy extra domain
                    </Button>
                  </Fragment>
                )}
                <EditDomainModal
                  showPremium={showPremiumEdit}
                  handleSubmit={this.editDomain}
                  showModal={showModalEdit}
                  plan={subscription_plan}
                  checkShortCode={this.handleCheckShortCode}
                  closeModal={this.toggleModalEdit}
                />
                <CreateDomainModal
                  checkShortCode={this.handleCheckShortCode}
                  showPremium={showPremiumCreate}
                  handleSubmit={this.createDomain}
                  plan={subscription_plan}
                  showModal={showModal}
                  closeModal={this.toggleModal}
                />
                <DeleteDomainModal
                  handleDelete={this.deleteDomain}
                  showModal={showModalDelete}
                  closeModal={this.toggleModalDelete}
                />
                <TrialUpgradeModal
                  isShown={showModalTrial}
                  closeModal={this.toggleModalTrial}
                />
              </div>
            </div>
            <div className="domains__content">
              {accounts.length !== 0 && accounts.map(this.renderDomainCard)}
              {!accounts.length && (
                <div className="domain-emptycard" onClick={this.toggleModal}>
                  <div className="domain-emptycard__content">
                    <div className="pulse-itm">
                      <div className="pulse-itm__inner">
                        <img src={plusSvg} alt="danger" />
                      </div>
                    </div>
                    <div className="domain-emptycard__text">
                      Buy extra domain
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <FixedFooter />
      </Fragment>
    );
  }
}

function mapStateProps(state) {
  return {
    accounts: state.content.accounts,
    details: state.details.user,
    state: state,
  };
}

const mapDispatchToProps = {
  showAccountsAction,
  createAccountAction,
  deleteAccountAction,
  updateAccountAction,
  checkShortcodeStatus,
};
export default connect(
  mapStateProps,
  mapDispatchToProps,
)(Domain);



// WEBPACK FOOTER //
// ./src/scenes/Domain/Domain.js